import { gql } from 'react-apollo';

export const getSubjectSpecificBucketsQuery = gql`
  query SubjectSpecificBucketsQuery($masterSubjectId: Int!) {
    dynamicQuizBuckets(masterSubjectId: $masterSubjectId) {
      name
      buckets {
        name
        mcq {
          min
          max
        }
        frq {
          min
          max
        }
      }
    }
  }
`;

export const CreateDynamicAssessment = gql`
  mutation CreateDynamicQuiz(
    $masterSubjectId: Int!
    $title: String!
    $mcqLength: Int
    $frqLength: Int
    $number: Int!
    $excludeInterval: Int!
    $bucketsConfiguration: [BucketConfigInputType]
    $ignoreErrors: Boolean!
  ) {
    createDynamicQuiz(
      masterSubjectId: $masterSubjectId
      title: $title
      mcqLength: $mcqLength
      frqLength: $frqLength
      number: $number
      excludeInterval: $excludeInterval
      bucketsConfiguration: $bucketsConfiguration
      ignoreErrors: $ignoreErrors
    ) {
      quizzesDetails {
        itemId
        title
      }
      message
      errors
      warnings
    }
  }
`;
